import getActionCable, { createWebsocketListener } from '../../../utils/actioncable';
import { actions } from './index';
import { setDisplayedIncidentId } from '../dashboards/actions';
import createMetadataAPIOperations from '../../utils/api-metadata-operations';

const connections = [];
const options = {
  name: 'incidents',
  baseType: 'INCIDENTS',
  apiEndpoint: 'incidents'
};

const defaultOperations = createMetadataAPIOperations(options);

// bound actions
export const registerForIncidentUpdates = groupId => dispatch => {
  // don't allow more than 1 connection for the same group
  if (connections.includes(groupId)) return;
  connections.push(groupId);

  const channelData = {
    channel: 'IncidentNotificationsChannel',
    group_id: groupId ? String(groupId) : null
  };

  // const callAPI = () => {
  //   const updated_after = moment().subtract(5, 'minute').toISOString();
  //   dispatch(defaultOperations.fetch({ forceFetch: true, params: { updated_after } }));
  // };

  const connectHandler = () => console.log('Connected to IncidentNotificationsChannel!');

  const receivedHandler = data => {
    dispatch(actions.fetchSuccessful([data], { replace: false }));
    dispatch(setDisplayedIncidentId(data.id));
  };

  const listener = createWebsocketListener({
    dispatch,
    connectHandler,
    receivedHandler,
    fallbackPoller: null, // Poller disabled; restore with callAPI
    fallbackPollerInterval: 5000
  });

  try {
    getActionCable().subscriptions.create(channelData, listener);
  } catch (error) {
    console.log(error);
  }
};

export default {
  ...defaultOperations,
  registerForIncidentUpdates
};
